import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'receivers'
})
export class ReceiversPipe implements PipeTransform {

  //获取当前dom节点
  constructor(private dom: DomSanitizer) { }

  transform(value: string,allUser:any[]): any {
    if(value){
      let userNames = []
      let ids = value.split(',')
      ids.forEach(item=>{
        let i = allUser.findIndex(v=>v.id == item)
        if(i != -1){
          userNames.push(allUser[i]['text'])
        }
      })
      let str = userNames.join(',')
      return str
    }
  }

}
